import {
    ChallengeLeaderboardType,
    LeaderboardDateFilterType,
    LeaderboardGenderMode,
    LeaderboardMetric,
    WorkoutCategory
} from '@core/api/ChallengeClient';

// Date filter type options for the dropdown
export const DATE_FILTER_TYPE_OPTIONS = [
    { value: LeaderboardDateFilterType.TODAY, label: 'Today' },
    { value: LeaderboardDateFilterType.WEEK, label: 'Week' },
    { value: LeaderboardDateFilterType.MONTH, label: 'Month' },
    { value: LeaderboardDateFilterType.LAST30DAYS, label: 'Last 30 Days' },
    { value: LeaderboardDateFilterType.LAST90DAYS, label: 'Last 90 Days' },
    { value: LeaderboardDateFilterType.CUSTOM, label: 'Custom' }
] as const;

// Metric options for activity category filters
export const METRIC_OPTIONS = [
    { value: LeaderboardMetric.ACTIVITY_POINTS, label: 'Activity Points' },
    { value: LeaderboardMetric.STEPS, label: 'Steps' },
    { value: LeaderboardMetric.DISTANCE, label: 'Distance' },
    { value: LeaderboardMetric.TIME, label: 'Time' },
    { value: LeaderboardMetric.REWARDS, label: 'Rewards' },
    { value: LeaderboardMetric.COMPOSITE_POINTS, label: 'Composite Points' },
    { value: LeaderboardMetric.CHALLENGE, label: 'Challenge' }
] as const;

// Which of a challenge's own leaderboards the tab shows
export const CHALLENGE_LEADERBOARD_TYPE_OPTIONS = [
    { value: ChallengeLeaderboardType.MEMBER, label: 'Members' },
    { value: ChallengeLeaderboardType.TEAM, label: 'Teams' },
    { value: ChallengeLeaderboardType.TEAM_MEMBER, label: 'Team members' }
] as const;

// Gender split. Members only -- team boards would have their totals move with it.
export const GENDER_MODE_OPTIONS = [
    { value: LeaderboardGenderMode.DISABLED, label: 'Off' },
    { value: LeaderboardGenderMode.SELECTABLE, label: 'Member chooses' },
    { value: LeaderboardGenderMode.FEMALE, label: 'Women only' },
    { value: LeaderboardGenderMode.MALE, label: 'Men only' }
] as const;

// Workout category options
export const TIME_WORKOUT_CATEGORY_OPTIONS = [
    { value: WorkoutCategory.TEAM_SPORTS, label: 'Team Sports' },
    { value: WorkoutCategory.STATIONARY_TRAININGS, label: 'Stationary Trainings' }
] as const;

export const DISTANCE_WORKOUT_CATEGORY_OPTIONS = [
    { value: WorkoutCategory.FOOT, label: 'Foot' },
    { value: WorkoutCategory.WHEELS, label: 'Wheels' },
    { value: WorkoutCategory.WATER, label: 'Water' },
    { value: WorkoutCategory.WINTER, label: 'Winter' },
    { value: WorkoutCategory.OTHER, label: 'Other' }
] as const;

// ID generators for drag and drop
export const getDragId = {
    dateFilter: (index: number) => `date-filter-${index}`,
    activityFilter: (index: number) => `activity-filter-${index}`
} as const;
